/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderRequestResponseItem
 */
export interface ProviderRequestResponseItem {
    /**
     * 
     * @type {string}
     * @memberof ProviderRequestResponseItem
     */
    requestId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProviderRequestResponseItem
     */
    providerName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderRequestResponseItem
     */
    hasRequest?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderRequestResponseItem
     */
    hasResponse?: boolean;
}

export function ProviderRequestResponseItemFromJSON(json: any): ProviderRequestResponseItem {
    return ProviderRequestResponseItemFromJSONTyped(json, false);
}

export function ProviderRequestResponseItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderRequestResponseItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'providerName': !exists(json, 'providerName') ? undefined : json['providerName'],
        'hasRequest': !exists(json, 'hasRequest') ? undefined : json['hasRequest'],
        'hasResponse': !exists(json, 'hasResponse') ? undefined : json['hasResponse'],
    };
}

export function ProviderRequestResponseItemToJSON(value?: ProviderRequestResponseItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'requestId': value.requestId,
        'providerName': value.providerName,
        'hasRequest': value.hasRequest,
        'hasResponse': value.hasResponse,
    };
}


